import React from 'react';
import { Container } from 'react-bootstrap';
import Particle from './Particle';

function NotFound(props) {
	let english = {
		"notfound": "Page not found."
	};

	let polish = {
		"notfound": "Nie znaleziono takiej strony."
	};

	let language = '';
	if (props.language === 'english') {
		language = english;
	} else {
		language = polish;
	}

	return (
		<section>
			<Container fluid className='notfound-section'>
				<Particle />
				<h1>{language.notfound}</h1>
			</Container>
		</section>
	);
}

export default NotFound;
